/**
 * Microdose cart Code entry — Acquisition Credits (FRIENDS50 / ____50).
 * Apply/remove via Cart Ajax API; hydrate UI from cart JSON.
 * Writes first acquisition code to cart attribute md_acquisition_code (never overwrite).
 */
(function () {
  'use strict';

  var DEFAULT_FRIENDS_CODE = 'FRIENDS50';
  var ATTR_ACQUISITION = 'md_acquisition_code';
  var STORAGE_DISCOUNT = 'md_checkout_discount';
  var rootPath =
    (window.Shopify && Shopify.routes && Shopify.routes.root) ||
    (window.routes && window.routes.root) ||
    '/';

  function money(cents, format) {
    cents = Number(cents) || 0;
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    var amount = (cents / 100).toFixed(2);
    if (!format) return '$' + amount;
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function friendsCodeKey(root) {
    var fromDom = root && root.getAttribute('data-friends-code');
    return String(fromDom || DEFAULT_FRIENDS_CODE).toUpperCase();
  }

  /** Decode HTML entities from data-i18n-* attributes (Liquid escape + section re-render). */
  function i18nAttr(root, name, fallback) {
    var raw = root && root.getAttribute(name);
    if (!raw) return fallback || '';
    if (raw.indexOf('&') === -1) return raw;
    var el = document.createElement('textarea');
    el.innerHTML = raw;
    return el.value || fallback || '';
  }

  function labelLooksLikeFriends(label, root) {
    var key = friendsCodeKey(root);
    var text = String(label || '').toUpperCase();
    return text.indexOf(key) !== -1;
  }

  /** Acquisition group: FRIENDS50 or vanity ____50 (letters + 50). */
  function isAcquisitionCode(code) {
    var c = String(code || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '');
    if (!c) return false;
    if (c === DEFAULT_FRIENDS_CODE) return true;
    return /^[A-Z]{2,20}50$/.test(c);
  }

  /** Light swear / insult filter for a cute rejection (not exhaustive). */
  function looksSassy(code) {
    var c = String(code || '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
    if (!c) return false;
    var hits = [
      'fuck',
      'fuk',
      'shit',
      'bitch',
      'asshole',
      'bastard',
      'damn',
      'crap',
      'dick',
      'cock',
      'pussy',
      'cunt',
      'slut',
      'whore',
      'fag',
      'nigger',
      'nigga',
      'retard',
      'bastard',
      'bollocks',
      'wanker',
      'twat',
      'prick',
      'piss',
      'hellno',
      'stupid',
      'idiot',
      'dumbass',
    ];
    for (var i = 0; i < hits.length; i++) {
      if (c.indexOf(hits[i]) !== -1) return true;
    }
    return false;
  }

  function appLabel(app) {
    return String((app && (app.title || app.code)) || 'Coupon').trim() || 'Coupon';
  }

  function fillTemplate(template, vars) {
    return String(template || '')
      .replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
        return vars[key] != null ? String(vars[key]) : '';
      })
      .replace(/\[(\w+)\]/g, function (_, key) {
        return vars[key] != null ? String(vars[key]) : '';
      });
  }

  function discountApps(cart) {
    return (cart && cart.cart_level_discount_applications) || [];
  }

  function primaryCode(cart) {
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i] && codes[i].code && codes[i].applicable !== false) {
        return String(codes[i].code);
      }
    }
    var apps = discountApps(cart);
    if (apps.length) return appLabel(apps[0]);
    return '';
  }

  function cartAttr(cart, key) {
    var attrs = (cart && cart.attributes) || {};
    return attrs[key] != null ? String(attrs[key]).trim() : '';
  }

  function bannerMessage(root, cart, format) {
    var apps = discountApps(cart);
    if (!apps.length) return '';

    var code = primaryCode(cart);
    if (labelLooksLikeFriends(code, root) || labelLooksLikeFriends(appLabel(apps[0]), root)) {
      return i18nAttr(root, 'data-i18n-friends-banner', 'New Friends $50 Credit Applied');
    }

    if (isAcquisitionCode(code)) {
      return i18nAttr(root, 'data-i18n-acquisition-banner', '$50 credit applied');
    }

    var primary = apps[0];
    var amount = money(primary.total_allocated_amount, format);
    var tmpl =
      i18nAttr(root, 'data-i18n-credit-banner', '[code] — [amount] credit applied');
    return fillTemplate(tmpl, { code: appLabel(primary), amount: amount });
  }

  function cartUrl(path) {
    return (rootPath.replace(/\/?$/, '/') + path.replace(/^\//, '')).replace(/([^:]\/)\/+/g, '$1');
  }

  function parseJson(res) {
    return res.text().then(function (text) {
      var data = null;
      if (text) {
        try {
          data = JSON.parse(text);
        } catch (e) {
          data = null;
        }
      }
      return { ok: res.ok, status: res.status, data: data, text: text };
    });
  }

  function fetchCart() {
    return fetch(cartUrl('cart.js'), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(parseJson)
      .then(function (result) {
        if (!result.ok || !result.data) throw new Error('Could not load cart');
        return result.data;
      });
  }

  function updateCart(payload) {
    return fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload || {}),
    }).then(parseJson);
  }

  function updateDiscount(code, extraAttributes) {
    var body = { discount: code == null ? '' : String(code) };
    if (extraAttributes && typeof extraAttributes === 'object') {
      body.attributes = extraAttributes;
    }
    return updateCart(body);
  }

  function rememberCheckoutDiscount(code) {
    try {
      if (code) sessionStorage.setItem(STORAGE_DISCOUNT, String(code).trim());
      else sessionStorage.removeItem(STORAGE_DISCOUNT);
    } catch (e) {}
  }

  function recalledCheckoutDiscount() {
    try {
      return sessionStorage.getItem(STORAGE_DISCOUNT) || '';
    } catch (e) {
      return '';
    }
  }

  /**
   * Also hit /discount/CODE so Shopify's checkout session keeps the code
   * (cart/update.js alone sometimes drops it at checkout).
   */
  function syncDiscountCookie(code) {
    var trimmed = String(code || '').trim();
    if (!trimmed) return Promise.resolve();
    var url = cartUrl('discount/' + encodeURIComponent(trimmed));
    return fetch(url, {
      credentials: 'same-origin',
      redirect: 'manual',
    }).catch(function () {});
  }

  function applicableDiscountCodes(cart) {
    var codes = (cart && cart.discount_codes) || [];
    var out = [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i] && codes[i].code && codes[i].applicable !== false) {
        out.push(String(codes[i].code).trim());
      }
    }
    if (!out.length) {
      var remembered = recalledCheckoutDiscount();
      if (remembered) out.push(remembered);
    }
    return out;
  }

  function checkoutUrlWithDiscount(codes) {
    var base = cartUrl('checkout');
    if (!codes || !codes.length) return base;
    var joined = codes
      .map(function (c) {
        return encodeURIComponent(c);
      })
      .join(',');
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'discount=' + joined;
  }

  function goToCheckoutWithDiscount(e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var checkoutBtn = target.closest(
      'button[name="checkout"], .cart__checkout-button, input[name="checkout"]'
    );
    var checkoutLink = target.closest('a[href*="/checkout"]');
    if (!checkoutBtn && !checkoutLink) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    fetchCart()
      .then(function (cart) {
        var codes = applicableDiscountCodes(cart);
        var primary = codes[0] || primaryCode(cart) || recalledCheckoutDiscount();
        if (primary) {
          rememberCheckoutDiscount(primary);
          return syncDiscountCookie(primary).then(function () {
            return checkoutUrlWithDiscount(codes.length ? codes : [primary]);
          });
        }
        return checkoutUrlWithDiscount([]);
      })
      .then(function (url) {
        window.location.href = url;
      })
      .catch(function () {
        window.location.href = cartUrl('checkout');
      });
  }

  /**
   * First acquisition code wins — write once to cart attributes for order/affiliate handoff.
   * Does not clear on remove (Brief: attributed code recorded once).
   */
  function ensureAcquisitionAttr(cart, appliedCode) {
    if (!isAcquisitionCode(appliedCode)) return Promise.resolve(cart);
    if (cartAttr(cart, ATTR_ACQUISITION)) return Promise.resolve(cart);

    var attrs = {};
    attrs[ATTR_ACQUISITION] = String(appliedCode).trim().toUpperCase();
    return updateCart({ attributes: attrs }).then(function (result) {
      if (result.ok && result.data) return result.data;
      return cart;
    });
  }

  function setError(root, message) {
    var el = root.querySelector('[data-md-discount-error]');
    var banner = root.querySelector('[data-md-discount-banner]');
    if (!el) return;
    if (message) {
      el.hidden = false;
      el.textContent = message;
      root.classList.add('is-error');
      root.classList.remove('is-applied');
      if (banner) {
        banner.hidden = true;
        banner.textContent = '';
      }
    } else {
      el.hidden = true;
      el.textContent = '';
      root.classList.remove('is-error');
    }
  }

  function setActionMode(root, mode) {
    var btn = root.querySelector('[data-md-discount-submit]');
    if (!btn) return;
    var applyLabel = i18nAttr(root, 'data-i18n-apply', 'Apply code');
    var removeLabel = i18nAttr(root, 'data-i18n-remove', 'Remove code');
    if (mode === 'remove') {
      btn.setAttribute('aria-label', removeLabel);
      btn.setAttribute('data-md-action', 'remove');
    } else {
      btn.setAttribute('aria-label', applyLabel);
      btn.setAttribute('data-md-action', 'apply');
    }
  }

  function updateTotals(cart) {
    document
      .querySelectorAll('.cart-drawer__footer .totals__total-value, .js-contents .totals__total-value')
      .forEach(function (el) {
        var root =
          el.closest('[data-md-cart-discount]') || document.querySelector('[data-md-cart-discount]');
        var format = root && root.getAttribute('data-money-format');
        el.textContent = money(cart.total_price, format);
      });
  }

  function renderRoot(root, cart) {
    if (!root || !cart) return;

    var banner = root.querySelector('[data-md-discount-banner]');
    var input = root.querySelector('[data-md-discount-input]');
    var format = root.getAttribute('data-money-format');
    var apps = discountApps(cart);
    var applied = apps.length > 0;
    var code = primaryCode(cart);
    var bannerText = bannerMessage(root, cart, format);

    root.classList.toggle('is-applied', applied);
    if (applied) root.classList.remove('is-error');

    if (input) {
      if (applied && code) {
        input.value = code;
        input.setAttribute('readonly', 'readonly');
      } else if (!root.classList.contains('is-error')) {
        input.removeAttribute('readonly');
      }
    }

    setActionMode(root, applied ? 'remove' : 'apply');

    if (banner) {
      if (applied && bannerText) {
        banner.hidden = false;
        banner.textContent = bannerText;
      } else {
        banner.hidden = true;
        banner.textContent = '';
      }
    }

    if (applied) {
      var err = root.querySelector('[data-md-discount-error]');
      if (err) {
        err.hidden = true;
        err.textContent = '';
      }
    }

    updateTotals(cart);
  }

  function renderAll(cart) {
    document.querySelectorAll('[data-md-cart-discount]').forEach(function (root) {
      renderRoot(root, cart);
    });
  }

  function bumpTierBar() {
    try {
      if (typeof window.__cartTierUpdate === 'function') window.__cartTierUpdate();
    } catch (e) {}
  }

  function refreshUi(cart) {
    var done = Promise.resolve(cart);
    if (!cart) done = fetchCart();
    return done.then(function (latest) {
      renderAll(latest);
      bumpTierBar();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.dispatchEvent(
        new CustomEvent('microdose:cart-updated', { detail: { cart: latest, source: 'microdose-cart-discount' } })
      );
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'microdose-cart-discount',
          cartData: latest,
        });
      }
      // Tier bar reads /cart.js — give Shopify a beat after discount clear, then recalc again
      setTimeout(bumpTierBar, 150);
      setTimeout(bumpTierBar, 500);
      return latest;
    });
  }

  function looksOncePerCustomer(payload) {
    var blob = '';
    try {
      blob = JSON.stringify(payload || {}).toLowerCase();
    } catch (e) {
      blob = String(payload || '').toLowerCase();
    }
    return (
      blob.indexOf('once per customer') !== -1 ||
      blob.indexOf('one use per customer') !== -1 ||
      blob.indexOf('already been used') !== -1 ||
      blob.indexOf('customer already used') !== -1 ||
      blob.indexOf('usage limit') !== -1
    );
  }

  function failMessage(root, attemptedCode, cartBefore, result) {
    if (result && looksOncePerCustomer(result.data || result.text)) {
      return (
        i18nAttr(
          root,
          'data-i18n-once-per-customer',
          'This credit is one per customer — try again at checkout with your email, or use a different email if you’ve ordered before.'
        )
      );
    }
    var already = cartAttr(cartBefore, ATTR_ACQUISITION);
    var hasApplied = discountApps(cartBefore).length > 0;
    if (
      (already || hasApplied) &&
      isAcquisitionCode(attemptedCode) &&
      String(already || primaryCode(cartBefore) || '').toUpperCase() !==
        String(attemptedCode).trim().toUpperCase()
    ) {
      return (
        i18nAttr(
          root,
          'data-i18n-already-used',
          'A $50 credit is already applied — only one acquisition credit works per customer.'
        )
      );
    }
    return i18nAttr(
      root,
      'data-i18n-error',
      "This code can't be applied — it may be invalid or not available for your account."
    );
  }

  function applyCode(root, code) {
    var submit = root.querySelector('[data-md-discount-submit]');
    var input = root.querySelector('[data-md-discount-input]');
    var trimmed = String(code || '').trim();
    if (!trimmed) {
      setError(
        root,
        i18nAttr(
          root,
          'data-i18n-error',
          "This code can't be applied — it may be invalid or not available for your account."
        )
      );
      if (input) input.focus();
      return Promise.resolve();
    }

    if (looksSassy(trimmed)) {
      setError(
        root,
        i18nAttr(root, 'data-i18n-sassy', 'Easy tiger — that one’s not a code. Try something nicer.')
      );
      if (input) {
        input.focus();
        input.select();
      }
      setActionMode(root, 'remove');
      return Promise.resolve();
    }

    setError(root, '');
    if (submit) submit.disabled = true;

    return fetchCart()
      .then(function (cartBefore) {
        return updateDiscount(trimmed).then(function (result) {
          return { result: result, cartBefore: cartBefore };
        });
      })
      .then(function (ctx) {
        var result = ctx.result;
        var data = result.data || {};
        var failed =
          !result.ok ||
          data.status === 422 ||
          (data.discount_codes &&
            data.discount_codes.some(function (d) {
              return (
                String(d.code || '').toUpperCase() === trimmed.toUpperCase() && d.applicable === false
              );
            }));

        if (failed) {
          setError(root, failMessage(root, trimmed, ctx.cartBefore, result));
          if (input) {
            input.value = trimmed;
            input.focus();
            input.select();
          }
          setActionMode(root, 'remove');
          root.classList.add('is-error');
          return null;
        }

        var cart = data.items ? data : null;
        var applied = trimmed;
        rememberCheckoutDiscount(applied);
        return syncDiscountCookie(applied)
          .then(function () {
            return cart ? Promise.resolve(cart) : fetchCart();
          })
          .then(function (latest) {
            return ensureAcquisitionAttr(latest, applied);
          })
          .then(function (latest) {
            return refreshUi(latest);
          });
      })
      .catch(function () {
        setError(
          root,
          i18nAttr(
            root,
            'data-i18n-error',
            "This code can't be applied — it may be invalid or not available for your account."
          )
        );
        if (input) input.value = trimmed;
        setActionMode(root, 'remove');
        root.classList.add('is-error');
      })
      .then(function () {
        if (submit) submit.disabled = false;
      });
  }

  function removeCode(root) {
    var input = root.querySelector('[data-md-discount-input]');
    var submit = root.querySelector('[data-md-discount-submit]');
    setError(root, '');
    if (submit) submit.disabled = true;

    // Clear active discount only — keep md_acquisition_code for first-touch attribution.
    rememberCheckoutDiscount('');
    return updateDiscount('')
      .then(function (result) {
        if (!result.ok) throw new Error('remove failed');
        if (input) {
          input.value = '';
          input.removeAttribute('readonly');
        }
        root.classList.remove('is-applied', 'is-error');
        setActionMode(root, 'apply');
        return refreshUi(result.data && result.data.items ? result.data : null);
      })
      .catch(function () {
        setError(root, 'Could not remove code. Please try again.');
      })
      .then(function () {
        if (submit) submit.disabled = false;
      });
  }

  function clearErrorState(root) {
    var input = root.querySelector('[data-md-discount-input]');
    setError(root, '');
    if (input) {
      input.value = '';
      input.removeAttribute('readonly');
      input.focus();
    }
    setActionMode(root, 'apply');
  }

  function onSubmit(e) {
    var form = e.target.closest('[data-md-discount-form]');
    if (!form) return;
    e.preventDefault();
    var root = form.closest('[data-md-cart-discount]');
    if (!root) return;
    var btn = root.querySelector('[data-md-discount-submit]');
    var action = btn && btn.getAttribute('data-md-action');
    var input = form.querySelector('[data-md-discount-input]');

    if (action === 'remove') {
      if (root.classList.contains('is-applied')) removeCode(root);
      else clearErrorState(root);
      return;
    }

    applyCode(root, input && input.value);
  }

  function onClick(e) {
    var btn = e.target.closest('[data-md-discount-submit]');
    if (!btn) return;
    var root = btn.closest('[data-md-cart-discount]');
    if (!root) return;
    if (btn.getAttribute('data-md-action') === 'remove') {
      e.preventDefault();
      if (root.classList.contains('is-applied')) removeCode(root);
      else clearErrorState(root);
    }
  }

  function hydrate() {
    fetchCart()
      .then(function (cart) {
        var code = primaryCode(cart);
        if (code) {
          rememberCheckoutDiscount(code);
          syncDiscountCookie(code);
        }
        return ensureAcquisitionAttr(cart, code).then(function (latest) {
          renderAll(latest || cart);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('submit', onSubmit);
  document.addEventListener('click', onClick);
  // Capture phase so we beat Dawn form POST and attach ?discount= for checkout
  document.addEventListener('click', goToCheckoutWithDiscount, true);
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      var checkoutCtrl =
        (e.submitter && e.submitter.getAttribute && e.submitter.getAttribute('name') === 'checkout' && e.submitter) ||
        form.querySelector('[name="checkout"]');
      if (!checkoutCtrl) return;
      goToCheckoutWithDiscount({
        target: checkoutCtrl,
        preventDefault: function () {
          e.preventDefault();
        },
        stopPropagation: function () {
          e.stopPropagation();
        },
        stopImmediatePropagation: function () {
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        },
      });
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(hydrate, 250);
    });
  }
  window.addEventListener('microdose:cart-updated', function (e) {
    if (e.detail && e.detail.cart) renderAll(e.detail.cart);
    else hydrate();
  });
  document.addEventListener('cart:refresh', function () {
    setTimeout(hydrate, 250);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
